import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type ImageFileIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const ImageFileIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.gray.light350,
  ...props
}: ImageFileIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="3" y="4" width="18" height="16" rx="2" stroke={color} strokeWidth={1.5} />
      <circle cx="8.5" cy="9.5" r="1.5" stroke={color} strokeWidth={1.5} />
      <path
        d="M21 15L16.5 11.5C16.1 11.2 15.5 11.2 15.1 11.5L9 16"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 20L7.9 15.9C7.5 15.6 6.9 15.6 6.5 15.9L3 18.5"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
